import Layout from "@/layout";

export default {
  path: "/bulletin",
  component: Layout,
  redirect: "/bulletin/index",
  children: [
    {
      path: "index",
      name: "bulletin",
      component: () => import("@/views/bulletin"),
      meta: { title: "Bulletin", icon: "bulletin-v2", keepName: "bulletin", keepAlive: true },
    },
    {
      path: "announcements",
      name: "Announcements",
      component: () =>
        import(/* webpackChunkName: "bulletin-announcements" */ "@/views/bulletin/components/announcements-list"),
      meta: { title: "Announcements", activeMenu: "/bulletin/index", keepAlive: true, keepName: 'announcements-list' },
      hidden: true
    },
    {
      path: "staticlink",
      name: "Staticlink",
      component: () =>
        import(/* webpackChunkName: "bulletin-staticlink" */ "@/views/bulletin/components/static-link-list"),
      meta: { title: "Static Links", activeMenu: "/bulletin/index", keepAlive: true, keepName: 'static-link-list' },
      hidden: true
    },
  ]
}